import { Stack } from '@atgfr8/atg-ui-tailwind';
import { orderStore } from '@store/orders';
import { Component } from 'solid-js';
import { StopListContainerProps } from '@common/stops';

import { StopsList } from './StopsList';

export const StopListContainer: Component<StopListContainerProps> = (
  props: StopListContainerProps,
) => {
  return (
    <Stack spacing={2}>
      <StopsList
        heading="Top 10 Stops"
        stops={orderStore.topStops}
        setAddressFromStopList={props.setAddressFromStopList}
        customerId={orderStore.order.customerId}
      />
      <StopsList
        heading="Last 10 Stops"
        stops={orderStore.lastStops}
        setAddressFromStopList={props.setAddressFromStopList}
        customerId={orderStore.order.customerId}
      />
    </Stack>
  );
};
